module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notFound.title":"Whoops, 404","notFound.message":"The page you were looking for does not exist","notFound.back":"Get me out of here!"}}')
  delete Component.options._Ctor
}
